var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M4.05 1.578h9.9c.825 0 1.5.675 1.5 1.5v1.65c0 .6-.375 1.35-.75 1.725l-3.225 2.85c-.45.375-.75 1.125-.75 1.725v3.225c0 .45-.3 1.05-.675 1.275L9 16.203c-.975.6-2.325-.075-2.325-1.275v-3.975c0-.525-.3-1.2-.6-1.575l-2.85-3c-.375-.375-.675-1.05-.675-1.5V3.153c0-.9.675-1.575 1.5-1.575Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#403F3F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M8.197 1.578 4.5 7.503",
    opacity: 0.4
  })));
};
export default SvgFilter;